var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.showContent)?_c('div',{staticClass:"container mt-5 px-5"},[_c('h1',{staticClass:"mt-5 text-center"},[_vm._v("BQ.TV📺")]),_c('h5',{staticClass:"mt-3 text-center"},[_vm._v("Your best option for watching English TV shows and movies online.")])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }